if (!customElements.get('qva-card-swipe')) {
  customElements.define(
    'qva-card-swipe',
    class QvaCardSwipe extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-qva-swipe-track]');
        this.dots = Array.from(this.querySelectorAll('[data-qva-swipe-dot]'));

        if (!this.track || this.dots.length < 2) return;

        this.frame = null;
        this.onScroll = () => {
          if (this.frame) cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.updateDots());
        };

        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        this.updateDots();
      }

      disconnectedCallback() {
        if (this.track && this.onScroll) {
          this.track.removeEventListener('scroll', this.onScroll);
        }
        if (this.frame) cancelAnimationFrame(this.frame);
      }

      updateDots() {
        const width = this.track.clientWidth;
        if (!width) return;

        const activeIndex = Math.min(
          this.dots.length - 1,
          Math.max(0, Math.round(this.track.scrollLeft / width))
        );

        this.dots.forEach((dot, index) => {
          dot.classList.toggle('is-active', index === activeIndex);
        });
      }
    }
  );
}
